var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(Number.isInteger(_vm.obj))?_c('img',{staticClass:"imgOrTile",attrs:{"src":'/api/files/' + _vm.resources.texturesById[_vm.obj].file.physicalName}}):_c('canvas',{ref:"canvas",staticClass:"imgOrTile"})])}
var staticRenderFns = []

export { render, staticRenderFns }